export enum PaymentStatus {
  Confirmed = "confirmed",
  Declined = "declined",
  Pending = "pending",
}

export interface Recipient {
  _id: string;
  banned: boolean;
  username: string;
}

export interface Payment {
  _id: string;
  recipient: Recipient;
  wallet: string;
  amount: number;
  status: PaymentStatus;
  createdAt: Date;
  updatedAt: Date;
}

export interface Payout {
  id: string;
  login: string;
  summary: number;
  wallet: number;
  requestDate: string;
  status: string;
  activity: string;
}

export enum PayoutStatus {
  CONFIRMED = "confirmed",
  DECLINED = "declined",
  PENDING = "pending",
}
